import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, Data } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subscription } from 'rxjs/Subscription';

import { TranslateService } from '@ngx-translate/core';

import { Constantes } from '../../../shared/constantes';

import { Mensaje } from '../../../shared/models/mensaje';
import { DetalleSolicitud } from '../../../shared/models/detalle-solicitud';
import { TransaccionPse } from '../../../shared/models/transaccion-pse';

import { DetalleService } from '../../services/detalle.service';

import { AutenticacionService } from '../../../shared/services/autenticacion.service';
import { AlertaService } from '../../../shared/components/alerta/alerta.service';
import { SpinnerService } from '../../../shared/components/spinner/spinner.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs/Rx';
import { SolicitudService } from '../../../public/services/solicitud.service';

declare var $: any;

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css']
})
export class DetalleComponent implements OnInit, OnDestroy {
  detalle: DetalleSolicitud;
  transaccionesPse: TransaccionPse[];
  verTransaccionesPse: boolean = false;
  mostrarSeccionFinal: boolean = false;
  solicitudPaga: boolean = false;
  solicitudPagaSubscription: Subscription;
  consulta: boolean = false;
  deshabilitarBotonPse: boolean = false;
  errorDescargaPDF: string = 'Error al descargar el Histórico del Conductor, por favor intente más tarde.<br/>Señor usuario, si el error persiste: <br/>Por favor comunicarse a Línea a nivel nacional: 018000930060 o la línea en Bogotá:423 22 21. <br/>O puede escribir su caso al correo electrónico soporte@runt.com.co';

  @ViewChild('modal') modal: ElementRef;
  @ViewChild('modalText') modalText: ElementRef;
  @ViewChild('modalComfirmarPago') modalComfirmarPago: ElementRef;
  @ViewChild('modalTextComfirmarPago') modalTextComfirmarPago: ElementRef;

  subject = new Subject<String>();

  constructor(private translate: TranslateService,
    private autenticacionService: AutenticacionService,
    private detalleService: DetalleService,
    private alertaService: AlertaService,
    private spinnerService: SpinnerService,
    private activatedRoute: ActivatedRoute,
    private solicitudService: SolicitudService,
    private router: Router) { }

  ngOnInit() {
    this.consulta = this.activatedRoute.snapshot.queryParams['q'] == 'S' ? true : false;

    if (this.consulta) {
      this.spinnerService.show();
    }
    this.activatedRoute.data
      .subscribe(
      (data: Data) => {

        var respuesta = data['detalleSolicitud'];
        if (respuesta.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          this.detalle = respuesta.object;

          this.esSolicitudPaga(true);
          this.getErrorMsg(this.detalle.idSolicitud);

          if (respuesta.mensaje) {
            this.alertaService.success(respuesta.mensaje);
          }
        } else {
          this.alertaService.warning(respuesta.mensaje);
        }

        this.spinnerService.hide();
      }
      );

    this.validarSolicitudPaga();
  }

  getErrorMsg(idSolicitud) {
    this.detalleService.getMensaje(idSolicitud, 'HC_ERR_DESCARGA_PDF').subscribe(
      (data) => {
          if (data) {
            this.errorDescargaPDF  = data;
          }
        }
      );
  }

  validarSolicitudPaga() {
    const solicitudPaga = Observable.interval(15000);

    this.solicitudPagaSubscription = solicitudPaga.subscribe(
      (number: number) => {
        console.log(number);
        this.esSolicitudPaga(false);
      }
    );
  }

  esSolicitudPaga(consultaPse: boolean) {
    this.detalleService.estaSolicitudPaga(this.detalle.idSolicitud, consultaPse)
      .subscribe(
      (data) => {
        this.solicitudPaga = data;

        if (this.solicitudPaga) {
          this.solicitudPagaSubscription.unsubscribe();
        }

        this.mostrarSeccionFinal = true;
      },
      (error) => { this.alertaService.error('Error al validar la solicitud paga, por favor intente mas tarde.') }
      );
  }

  abrirTransaccionesPse() {
    this.spinnerService.show();

    this.detalleService.consultarTransaccionesPse(this.detalle.idSolicitud)
      .subscribe(
      (data) => {
        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          this.transaccionesPse = data.object;

          this.verTransaccionesPse = true;

          this.spinnerService.hide();
        } else {
          this.alertaService.warning(data.mensaje);
        }
      },
      (error) => { this.alertaService.error('Error al consultar el detalle de transacciones PSE, por favor intente mas tarde.') }
      );
  }

  volverTransaccionesPse() {
    this.spinnerService.show();

    this.transaccionesPse = [] as TransaccionPse[];
    this.verTransaccionesPse = false;

    this.spinnerService.hide();
  }

  crearTransaccionPse() {
    this.spinnerService.show();

    this.deshabilitarBotonPse = true;

    this.spinnerService.hide();
    $(this.modalComfirmarPago.nativeElement).modal('show');
    $(this.modalTextComfirmarPago.nativeElement).html("Para realizar el pago será dirigido al portal de pagos en línea del RUNT");

    this.deshabilitarBotonPse = false;
    /*this.detalleService.crearTransaccionPse(this.detalle.idSolicitud, 'q=S')
      .subscribe(
      (data) => {
        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {

          // window.open(data.object.urlPSEHosting, '_blank', 'toolbar=0,location=0,menubar=0');
          window.location.href = data.object.urlPSEHosting;

          this.spinnerService.hide();
        } else {
          if (data.mensaje) {
            this.alertaService.warning(data.mensaje);
          } else if (data.object.error) {
            this.alertaService.warning(data.object.mensajeError);
          }
        }

        this.deshabilitarBotonPse = false;
      },
      (error) => { this.alertaService.error('Error al crear la transaccion PSE, por favor intente mas tarde.') }
      );*/
  }

  descargarCertificado(sinInfoExterna: string) {
    this.spinnerService.show();
    $(this.modal.nativeElement).modal('hide');

    this.detalleService.getReporte(this.detalle.idSolicitud, sinInfoExterna)
      .subscribe(
      (data) => {
        if (data) {
          this.spinnerService.hide();

          var file = new Blob([data], { type: 'application/pdf' });
          window.open(window.URL.createObjectURL(file));
        } else {
          this.alertaService.error(this.errorDescargaPDF);
        }
      },
      (error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 601) {
            this.detalleService.getMensaje(this.detalle.idSolicitud, 'HC_MENSAJE_CONFIRMACION_DESCARGA_NO_SIMIT')
              .subscribe(
                (dataMje) => {
                  this.spinnerService.hide();
                  $(this.modal.nativeElement).modal('show');
                  $(this.modalText.nativeElement).html(dataMje);
                },
                (errorMje) => { this.alertaService.error('Error al consultar el mensaje de error 601.'); }
              );
          } else {
            this.alertaService.error(this.errorDescargaPDF);
          }
        }
      }
      );
  }

  cancelar() {
    this.autenticacionService.logout();

    if (this.consulta) {
      this.router.navigate(['/consulta']);
    } else {
      this.router.navigate(['/solicitud']);
    }
  }

  ngOnDestroy() {
    this.solicitudPagaSubscription.unsubscribe();
  }

  async continuarPago(){
    try {
      let data = await this.solicitudService.getParametros(Constantes.URL_NUEVO_PAGO).toPromise();
      window.open(data.valor + "hc/" + this.detalle.idSolicitud, '_parent');
    } catch (error) {
      this.alertaService.error('Error al consultar el prámetro, por favor intente mas tarde.')
    }

  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/components/detalle/detalle.component.ts